import { Injectable } from '@angular/core';
import { get, has, isArray, isEmpty, isObject, isString } from 'lodash';

@Injectable()
export class MessageParseService {
    getMessage(message: string | object) {
        const rawMessage = isObject(message) && has(message, 'message') ? get(message, 'message') : message;
        return this.getUserFriendlyMessage(rawMessage);
    }

    getCollectionDetails(message: string | object) {
        if (isObject(message) && (has(message, 'details') || has(message, 'error_details')))
            return this.getCollectionWithObject(message);
        else {
            const rawMessage = get(message, 'message');
            return [this.getUserFriendlyMessage(rawMessage)];
        }
    }

    private getCollectionWithObject(message: string | object) {
        const collectionDetails = [];
        const details = get(message, 'details') || (get(message, 'error_details') as any);
        if (has(message, 'message')) {
            const rawMessage = get(message, 'message');
            collectionDetails.push(this.getUserFriendlyMessage(rawMessage));
        }

        if (isString(details)) collectionDetails.push(this.getUserFriendlyMessage(details));
        else if (isArray(details))
            for (const detail of details)
                if (detail.gateway_specific_description) collectionDetails.push(detail.gateway_specific_description);
                else if (detail.description) collectionDetails.push(detail.description);
                else collectionDetails.push(this.getUserFriendlyMessage(detail));
        else if (details.gateway_specific_description && !isEmpty(details.gateway_specific_description))
            collectionDetails.push(details.gateway_specific_description);
        else if (details.description && !isEmpty(details.description)) collectionDetails.push(details.description);

        if (has(details, 'messages'))
            for (const detailsMessage of get(details, 'messages'))
                if (isString(detailsMessage)) collectionDetails.push(this.getUserFriendlyMessage(detailsMessage));
                else if (
                    detailsMessage.gateway_specific_description &&
                    !isEmpty(detailsMessage.gateway_specific_description)
                )
                    collectionDetails.push(detailsMessage.gateway_specific_description);

        return collectionDetails;
    }

    /**
     * Transforms technical error messages into user-friendly messages.
     */
    private getUserFriendlyMessage(message: string | unknown): string {
        if (!isString(message)) {
            return String(message);
        }

        if (message.includes('expressions must contain no more than')) {
            return 'Maximum limit of 1,000 entries per rule exceeded. Please reduce the number of entries and try again.';
        }

        return message;
    }
}
